import React from 'react';
import PropTypes from 'prop-types';
import Slides from '@ifeng/ui_pc_slides';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import Chip from 'Chip';
import { handleAd } from '../../../../../utils/utils';
import { Event } from '@ifeng/ui_base';

let flag = 0;

class BookRecommendSlide extends React.PureComponent {
    state = {
        data: this.props.bookRecommendData,
    };

    event = new Event();

    // insertArr 为广告方想要插入的一组位置，replaceArr 为广告方想要替换的一组位置，adFn 为回调方法
    insert = (insertArr, replaceArr, adFn) => {
        if (adFn && typeof adFn === 'function') {
            const { data } = this.state;

            console.log('insertArr', insertArr); // 要插入的数据的索引
            console.log('replaceArr', replaceArr); // 被替换的数据的索引
            const infoData = [...data];
            const refs = [];

            // 广告插入，在指定位置后插入广告位数据
            insertArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 0, { type: 'ad', ref });
            });

            // 广告替换，在指定位置删除原数据，替换为广告位数据
            replaceArr.forEach(item => {
                const ref = React.createRef();

                refs.push({ index: item, ref });

                infoData.splice(item, 1, { type: 'ad', ref });
            });

            // 广告数据整合处理完毕后，更新列表数据
            this.setState(
                {
                    data: infoData,
                },
                () => {
                    const dom = {};

                    for (const ref of refs) {
                        dom[ref.index] = ref.ref.current;
                    }

                    adFn(dom);
                },
            );
        }

        return;
    };

    async componentDidMount() {
        // 插入软广
        try {
            const { ad } = this.props;

            // const ad = {
            //     data: {},
            //     preload: '',
            //     callback: (data, event, insert) => {
            //         // event 为传入的 event 事件对象，用于广告方绑定事件
            //         // insert 为我们自定义的广告插入方法
            //         event.on('init', () => {
            //             // data 为我们触发方法时传参值
            //             const insertArr = [];

            //             const replaceArr = [2, 7, 12];

            //             insert(insertArr, replaceArr, dom => {
            //                 console.log('dom__', dom);
            //             });
            //         });
            //     },
            // };

            const callback = await handleAd(ad);

            callback(ad.data, this.event, this.insert); // 将自定义广告插入方法传入，这样广告方即可调用
        } catch (e) {
            console.error(e);
        }

        try {
            const data = this.props.bookRecommendData;

            // console.log('data__', data);
            // const recommendHotnews = this.props.recommendHotnewsLen;

            // console.log('data__', data);
            if (data) {
                this.setState(
                    {
                        data,
                    },
                    () => {
                        this.adInit(data); // 数据请求完毕，初始化时触发广告位插入方法，data 为可选的传参值
                    },
                );
            }
        } catch (e) {
            console.error(e);
        }
    }

    adInit = data => {
        try {
            this.event.trigger('init', { data }); // 触发广告位插入方法
        } catch (e) {
            console.error(e);
        }
    };

    sliderTmpl = list => {
        flag++;

        return (
            <div className={styles.slideItem}>
                {list && list.map
                    ? list.map((item, index) => {
                          if (item.type === 'ad') {
                              return (
                                  <a
                                      href={item.url}
                                      key={index}
                                      className={styles.link}
                                      imgindex={index}
                                      ref={item.ref}>
                                      {/* <img src={item.thumbnail} width="180px" height="122px" /> */}
                                      {/* <div className={styles.title}>{item.title}</div> */}
                                  </a>
                              );
                          } else {
                              return (
                                  <a href={item.url} key={index} className={styles.link} imgindex={index}>
                                      <img src={item.thumbnail} width="180px" height="122px" />
                                      <div className={styles.title}>{item.title}</div>
                                  </a>
                              );
                          }
                      })
                    : ''}
            </div>
        );
    };

    sliderTmplFo = list => {
        return (
            <div className={styles.slideItem}>
                {list && list.map
                    ? list.map((item, index) => (
                          <a href={item.url} key={index} className={styles.link} imgindex={index}>
                              <img src={item.thumbnail} width="180px" height="122px" />
                              <div className={styles.title}>{item.title}</div>
                          </a>
                      ))
                    : ''}
            </div>
        );
    };

    render() {
        let { data } = this.state;

        if (!(data instanceof Array)) {
            data = [];
        }

        // channelTitle根据不同频道进行，匹配数据
        const newList = [data.slice(0, 5), data.slice(5, 10), data.slice(10)];
        const config = {
            arrows: false,
            dotsAction: 'hover',
            autoplay: true,
            autoplayInterval: 6000,
            speed: 1000,
            sliderTmpl: this.sliderTmpl,
            dotStyle: styles.dot,
            dotCurrentStyle: styles.current,
            infinite: false,
        };

        return (
            <Chip id="75149" type="recommend" title="上推广" groupName="正文" content={data}>
                <div className={styles.container}>
                    <div className={styles.tit}>热门好书</div>
                    <div className={styles.box}>
                        <Slides content={newList} config={config} />
                    </div>
                </div>
            </Chip>
        );
    }
}

/**
 * 定义组件属性类型
 * */
BookRecommendSlide.propTypes = { bookRecommendData: PropTypes.array, ad: PropTypes.object };

/**
 * 定义组件默认属性
 * */
BookRecommendSlide.defaultProps = {};

export { BookRecommendSlide };
export default errorBoundary(BookRecommendSlide);
